import { ThemeConfig, Layout01ThemeCustomizations, Layout02ThemeCustomizations, Layout03ThemeCustomizations } from './index';


// This is the theme used when custom colors (or other future customization)
// are applied. This is (originally) based on the "Light" theme but we want
// a separate theme so that any changes to "Light" don't accidentally affect
// how "custom"-ized pages work.

const Custom: ThemeConfig = {
  colors:{
    main: '#007ACC'
  },
  page: {
    background: '#f8f8f8'
  },
  link: {
    textDecoration: 'underline'
  },
  characteristicFont: {
    fontWeight: '700',
  },
  mainTrackingStatus: {
    textTransform: 'uppercase',
    fontSize: '34px',
    lineHeight: '1.176'
  },
  signatureRequired: {
    background: '#95E4FD',
    color: '#222222'
  },
  card: {
    background: 'white',
    border: '1px solid #DFE3E8',
    borderRadius: '2px',
  },
  layoutSpecific: {
    layout01: {
      cardHeader: {
        shadow: ''
      },
      recentTrackingDot: {
        backgroundColor: '#007ACC'
      }
    } as Layout01ThemeCustomizations,
    layout02: {
      cardHeader: {
        shadow: ''
      },
      recentTrackingDot: {
        backgroundColor: '#007ACC'
      }
    } as Layout02ThemeCustomizations,
    layout03: {
      cardHeader: {
        shadow: ''
      },
      recentTrackingDot: {
        backgroundColor: '#007ACC'
      }
    } as Layout03ThemeCustomizations,
  }
};

export default Custom;